@if (showSpinner) {
  <div class="spinner-border loader alfalaval-blue-color spinner-center"></div>
}
<h3>Global Item Registry (GIR) Admin Tool</h3>
<p>Global Item Registry is the replacement for GIM (Global Item Master).</p>

<div class="row">
</div>

<!-- <div>
<pre style="margin-top:10px; border: 1px solid red; width: fit-content">
  {{ messagesPerDay | json }}
</pre>
</div> -->
